import React, { useEffect, useState } from "react";
import Style from "./AllCommentsPage.module.css";
import AllCommentsHeader from "../../Component/AllCommentsHeader/AllCommentsHeader";
import Comment from "../../Component/Comment/Comment";
import { getSupplierComments, getSupplierInfo } from "../../Api/BarestServices";
import PointSpreadLoading from "react-loadingg/lib/PointSpreadLoading";
import { errorToast } from "../../Toast/Toast";

const AllCommentsPage = (props) => {
  const [Details, setDetails] = useState([]);
  const [supplierComments, setsupplierComments] = useState();
  useEffect(() => {
    getDetailResturan();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const getDetailResturan = async () => { 
    getSupplierInfo(props.location.state, (succ, res) => {
      if (succ) {
        if (res.status !== 1) {
          errorToast(res.message);
        } else {
          setDetails(res.supplier);
        }
      } else {
        console.error(res);
      }
    });
    getSupplierComments(props.location.state, (succ, res) => {
      if (succ) {
        if (res.status === 0) {
          errorToast(res.message);
        } else {
          setsupplierComments(res);
        }
      } else {
        console.error(res);
      }
    });
  };

  let loadingHandler = null;
  if (Details === undefined) {
    loadingHandler = (
      <div className={Style.loading2Test}>
        <PointSpreadLoading color={"#ab0c59"} size={"small"} />
      </div>
    );
  } else {
    loadingHandler = <AllCommentsHeader shopDetail={Details} />;
  }
  let CommentChecker = null;
  if (supplierComments === undefined) {
    CommentChecker = null;
  } else if (supplierComments.comments.length === 0) {
    CommentChecker = (
      <div className={Style.NotOrderFoundHolder}>
        <div className={Style.ImageBasket}>
          <img src="/Assets/Images/Comment/Comment.png" alt="برست" />
        </div>
        <p className={Style.NoOrderText}>نظری یافت نشد</p>
      </div>
    );
  } else {
    CommentChecker = supplierComments.comments.map((item, index) => {
      return <Comment key={index} commentDetail={item} />;
    });
  }

  return (
    <div className={Style.PageHolder}>
      {loadingHandler}
      <p className={Style.resturantNameHolder}>
        {Details === undefined ? "منتظربمانید" : Details.name}
      </p>
      {CommentChecker}
    </div>
  );
};

export default AllCommentsPage;
